import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "@vimaana/ui/styles";
// Kontor-Look (seit 09.10.2026): dieselben Farben, derselbe Rahmen, Hell und Dunkel.
import "@vimaana/ui/theme";
import "@vimaana/ui/shell";
import "@vimaana/ui/sektion";
import "./styles/pflege.css";
import App from "./App";
import { MUpdateBalken, bootTheme } from "@vimaana/ui";

bootTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <>
          {/* Meldet sich nur, wenn wirklich ein neuerer Stand ausgeliefert ist. */}
          <MUpdateBalken />
          <App />
        </>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
